import { render, staticRenderFns } from "./ShortCutKey.vue?vue&type=template&id=5f2be3a6&scoped=true"
import script from "./ShortCutKey.vue?vue&type=script&lang=js"
export * from "./ShortCutKey.vue?vue&type=script&lang=js"
import style0 from "./ShortCutKey.vue?vue&type=style&index=0&id=5f2be3a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2be3a6",
  null
  
)

export default component.exports